import { useQuery, useMutation, useQueryClient } from "react-query";
import { useDispatch } from "react-redux";
import { customApi } from "../../../CustomHoock/CustomApi";
const useGetAllOrdersInAllStepsCount = () => {
  return useQuery(
    ["GetAllPersonBankInfo"],
    () =>
      customApi({
        apiType: "get",
        url: "/api/v1/Dashboard/GetAllOrdersInAllStepsCount",
        reactQuery: "query",
      }),
    {
      refetchOnWindowFocus: false,
      onSuccess: (data) => {
        return data;
      },
      onError: () => {},
      select: (data) => {
        let res = data?.data.data;
        return res;
      },
    }
  );
};

const useGetOrdersStatusStatistics = (OrdersStatusStatistics) => {
  return useQuery(
    ["GetOrdersStatusStatistics"],
    () =>
      customApi({
        apiType: "get",
        url: "/api/v1/Dashboard/GetOrdersStatusStatistics",
        reactQuery: "query",
      }),
    {
      enabled: !!OrdersStatusStatistics,
      refetchOnWindowFocus: false,
      onSuccess: (data) => {
        return data;
      },
      onError: () => {},
      select: (data) => {
        let res = data?.data.data;
        return res;
      },
    }
  );
};
const useGetPersonelLeaveReport = () => {
  return useMutation(
      (date) =>
        customApi({
          apiType: "post",
          url: "/api/v1/Dashboard/GetPersonelLeaveReport",
          reactQuery: "mutate",
          requestBody: date,
        }),
   
    );
};
export {
  useGetAllOrdersInAllStepsCount,
  useGetOrdersStatusStatistics,
  useGetPersonelLeaveReport,
};
